export const SAFE_EMPTY_STRING = 'placeholder-6dd4ff9d-07ca-42ce-9c68-92fa95a0f558';
